<template>
  <div>
    <BubbleParams />

    <ScaleFactorSettings />

    <HollowBubbles />

    <BubblesLegendsSettings />

    <HaloBubblesSettings />

    <BubblesClusterAndHeadingPositions />

    <FieldSettings />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BubbleParams from '@/components/builder/BubbleParams/BubbleParams.vue'
import HollowBubbles from '@/components/builder/HollowBubbles/HollowBubbles.vue'
import FieldSettings from '@/components/builder/FieldSettings/FieldSettings.vue'
import ScaleFactorSettings from '@/components/builder/ScaleFactorSettings.vue'
import HaloBubblesSettings from '@/components/builder/HaloBubbles/HaloBubblesSettings.vue'
import BubblesLegendsSettings from '@/components/builder/BubblesLegendsSettings.vue'
import BubblesClusterAndHeadingPositions from '@/components/builder/BubblesClusterAndHeadingPositions.vue'

const components = {
  BubbleParams,
  FieldSettings,
  HollowBubbles,
  ScaleFactorSettings,
  HaloBubblesSettings,
  BubblesLegendsSettings,
  BubblesClusterAndHeadingPositions,
}

// eslint-disable-next-line no-use-before-define
@Component<BubblesSettingsView>({
  components,
})
export default class BubblesSettingsView extends Vue {}

</script>
